import * as types from './types'
import Clients from '../../../services/api/clients';
import Users from '../../../services/api/user';

const resolveDate = (date) => {
	let d = null
	if (date === null) {
		return null
	}

	if (date.indexOf('-') !== -1) {
		// Score date
		d = date.split('-')
	} else {
		// Slash date
		d = date.split('/')
	}
	if (d.length === 3) {
		if (d[2].toString().length === 4) {
			return d.join('-')
		} else {
			return d.reverse().join('-')
		}
	} else {
		return null
	}
}

export const actions = {
	getClients ({ commit }) {
		return new Promise((resolve, reject) => {
			Clients.getClients()
			.then(clients => {
				commit(types.SET_CLIENTS, clients)
				resolve()
			}).catch(() => {
				reject()
			})
		})
	},
	getClientById ({commit}, __id) {
		return new Promise((resolve, reject) => {
			Clients.getClientById(__id)
			.then(client => {
        commit(types.SET_CLIENT, client)
        resolve()
      })
      .catch(() => {
				reject()
			})
    })
	},
  addClient ({ commit }, __client) {
    return new Promise((resolve, reject) => {
			__client.birthdate = resolveDate(__client.birthdate)
      Clients.addClient(__client).then((client) => {
        commit(types.CREATE_CLIENT, {client})
        resolve()
      }).catch(() => {
				reject()
			})
    })
	},
	editClient ({commit}, __client) {
		console.log('call edit client')
		__client.birthdate = resolveDate(__client.birthdate)
		return new Promise((resolve, reject) => {
      Clients.editClient(__client).then((client) => {
				console.log('return from edit client', client)
        commit(types.EDIT_CLIENT, { client })
        resolve()
      }).catch((error) => {
				console.log(error)
				reject()
			})
    })
	},
  enableClient ({commit}, __id) {
		return new Promise((resolve, reject) => {
      Users.enableUser(__id)
      .then(() => {
        commit('ENABLE_CLIENT', __id)
        resolve()
      }).catch(() => {
				reject()
			})
    })
	},
  disableClient ({commit}, __id) {
		return new Promise((resolve, reject) => {
      Users.disableUser(__id)
      .then(() => {
        commit('DISABLE_CLIENT', __id)
        resolve()
      }).catch(() => {
				reject()
			})
    })
	},
	getClientEstateById ({commit}, __id) {
		return new Promise((resolve, reject) => {
			Clients.getClientEstateById(__id)
			.then(estate => {
        commit(types.SET_ESTATE, estate)
        resolve()
      })
      .catch(() => {
				reject()
			})
    })
	},
}



// WEBPACK FOOTER //
// ./src/store/modules/Clients/actions.js